




























































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import Apps from '@/store/modules/Apps';
import Decision from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import { v4 as uuidv4 } from 'uuid';
import CardTitle from '@/components/common/CardTitle.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import Viewpoints from '@/store/modules/Viewpoints';
import _ from 'lodash';
import Choices from '@/store/modules/Choices';
import Modelling from "@/store/modules/Modelling";
import FactorNavigationPublishedModel from '@/components/navigation/FactorNavigationPublishedModel.vue';
import FactorNavigation from "@/components/navigation/FactorNavigation.vue";
import { FactorGroup } from "@/api/model/FactorResource";
import { Urls } from "@/Urls";


const appModule = getModule(Apps);
const decisionModule = getModule(Decision);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const modellingModule = getModule(Modelling);

@Component({
    components: {
        CardTitle,
        DescriptionEditor,
        FactorNavigationTree: FactorNavigation,
        FactorNavigationPublishedModel
    },
})
export default class AppNavTreeAddEdit extends Vue {
    @Prop({ default: false, type: Boolean })
    appEmbed!: boolean;

    @Prop({default: false, type: Boolean})
    mainApp!: boolean;

    private open = false;
    private name = '';
    private href = '';
    private currentTab = '';
    private description = '';
    private error = false;
    private autocreate = false;
    private templateViewpoint: string = "";
    private includeWeights = true;
    private includeKeys = true;
    private includeScores = true;
    private activeViewpointInternal = '';
    private visibleViewpointsInternal = [];
    private activeChoiceInternal = '';
    private forceState = false;
    private createChoice = false;
    private filterViewpoints = false;
    private alerts = [];
    private urlParams = {};
    private showPreview = false;
    private searchFactors: string | null = null;
    private selectedFactors: string[] = [];
    private readonly widthOptions: any[] = WorkspaceOptionValues.WIDTH_OPTIONS;
    private firstColumnWidth: number = 0;
    private dataColumnWidth: number = 0;
    private activeFactorName: string = '';
    private sortOrder: number = 1;
    private urlLoaded = false;
    private uiDisableOverride = false;
    private brandingPrimary = '004466'
    private readonly panelVisible  = {
        'menu': ['factorSelectionMenu', 'choiceSelectionMenu', 'viewpointSelectionMenu' ],
        'viewpoints': [ 'autocreate', 'activeViewpointId', 'viewpointIds', 'viewpointListIds' ],
        'choices': [ 'createChoice', 'choiceId', 'choiceListIds' ],
        'factors': [ 'activeFactorId', 'factorListIds' ],
        'permissions': [ 'editModel', 'editContent', 'editWeights', 'editSumRule', 'editScoringRule', 'editScores', 'editComments' ],
        'ui': ['firstColumnWidth', 'dataColumnWidth', 'sortOrder', 'general-settings', 'score-settings', 'openLeft', 'pinnedLeft', 'branding']
    };
    private readonly propPaths = {
        // Selectors
        'activeFactorId': ['/template/builder', '/choice', '/card', '/weight', '/score/compare', '/score/choice', '/score/bins'],
        'activeViewpointId': ['/choices', '/score/compare', '/card'],
        'viewpointIds': ['/score/choice', '/score/bins', '/weight'],
        'choiceId': ['/choice', '/card', '/score/choice'],
        'createChoice': ['/choice', '/card', '/score/compare', '/score/choice', '/score/bins'],
        'autocreate': ['/choices', '/weight', '/score/compare', '/score/choice', '/score/bins' ],
        // UI 
        'firstColumnWidth': ['/weight', '/score/compare', '/score/choice'],
        'dataColumnWidth': ['/weight', '/score/compare', '/score/choice', '/score/bins'],
        'sortOrder': ['/score/compare', '/score/choice'],
        // General Settings
        'showComments': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'openLeft': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice', '/users', '/choices', '/viewpoint'],
        'openRight': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'pinnedRight': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'pinnedLeft': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice', '/users', '/choices', '/viewpoint'],
        'commentVertical': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'skipGroups': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'mbDraggable': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'chartTop': ['/card'],
        // Score Settings
        'showBars': ['/score/compare', '/score/choice', '/score/bins'],
        'showIconScoring': ['/score/compare', '/score/choice'],
        'denomScoring': ['/score/compare', '/score/choice'],
        'standardize': ['/score/compare', '/score/choice'],
        'includeKeys': ['/weight'],
        'includeWeights': ['/weight'],
        'showScores': ['/score/compare', '/score/choice'],
        'showKeys': ['/score/compare', '/score/choice'],
        'includeScores': ['/score/bins', '/score/compare', '/score/choice' ],
        'showDesc': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'showCustomRange': ['/template/builder', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        // Lock Selection
        'factorSelectionMenu': ['/score/compare', '/score/choice','/score/bins'],
        'choiceSelectionMenu': ['/score/compare', '/choice', '/card', '/score/choice'],
        'viewpointSelectionMenu': ['/choices', '/weight', '/score/compare', '/score/choice'],
        // Lists
        'viewpointListIds': ['/viewpoint', '/choice', '/card', '/score/compare', '/score/choice', '/score/bins'],
        'choiceListIds': ['/choices', '/choice', '/card', '/score/compare', '/score/choice', '/score/bins'],
        'factorListIds': ['/template/builder', '/choice', '/card', '/weight', '/score/compare', '/score/choice', '/score/bins'],
        // Permissions
        'editModel': ['/template/builder'],
        'editContent': ['/choice', '/card', '/score/choice'],
        'editWeights': ['/weight'],
        'editSumRule': ['/template/builder', '/weight'],
        'editScores': ['/score/compare', '/score/choice', '/score/bins'],
        'editComments': ['/template/builder', '/lists', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'editScoringRule': ['/template/builder', '/lists', '/weight', '/score/bins', '/score/compare', '/score/choice'],

        'general-settings': ['/template/builder', '/choice', '/card', '/weight', '/score/bins', '/score/compare', '/score/choice'],
        'score-settings': ['/score/compare', '/score/choice', '/score/bins', '/weight', '/template/builder', '/choice', '/card']
    };
    private sortOptions: any[] = [
        {
            id: 1,
            name: 'Alphabetical',
        },
        {
            id: 2,
            name: 'Overall Score - Low to High',
        },
        {
            id: 3,
            name: 'Overall Score - High to Low',
        },
        {
            id: 4,
            name: `${this.singularFactorLabel} - Low to High`,
        },
        {
            id: 5,
            name: `${this.singularFactorLabel} - High to Low`,
        },
    ];

    // update this prop passing from the parent
    @PropSync('item', { type: Object })
    syncedItem!: any;

    @Prop({ default: false, type: Boolean })
    isUpdate!: boolean;

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get activeChoiceId() {
        return choicesModule.selectedChoiceId
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree(this.startingFactors);
        }
    }

    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return 'M'
        }   
    }

    get lists() {
        return decisionModule.decisionLists;
    }

    get viewpointLists() {
        return _.values(decisionModule.decisionLists).filter(
            (list) => list.type === 'VIEWPOINT'
        );
    }

    get choiceLists() {
        return _.values(decisionModule.decisionLists).filter(
            (list) => list.type === 'CHOICE'
        );
    }

    get factorLists() {
        return _.values(decisionModule.decisionLists).filter(
            (list) => list.type === 'FACTOR'
        );
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get isFactorListActive() {
        if (workspaceOptionsModule.activeFactorLists) {
            return workspaceOptionsModule.activeFactorLists.length > 0
        }
        return false;
    }

    get lockSelection() {
        return !appModule.selectionMenu;
    }

    set lockSelection(selectionMenu: boolean) {
        appModule.setSelectionMenu(!selectionMenu);
    }

    get appList() {
        return appModule.appList;
    }

    get selectedAppId() {
        return appModule.selectedAppId;
    }

    get selectedApp() {
        if (this.appList && this.selectedAppId) {
            return this.appList.find((x) => x.id === this.selectedAppId);
        } else {
            return null;
        }
    }

    get singularViewpointLabel() {
        return decisionModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionModule.pluralViewpointLabel;
    }

    get singularChoiceLabel() {
        return decisionModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionModule.pluralChoiceLabel;
    }

    get singularFactorLabel() {
        return decisionModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionModule.pluralFactorLabel
    }

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get decisionName() {
        return decisionModule.selectedDecision.name;
    }

    get currentUrl(){
        return workspaceOptionsModule.currentUrl;
    }

    get isViewpointListActive(): boolean {
        return workspaceOptionsModule.activeViewpointLists.length > 0
    }

    get viewpoints() {
        if(this.isViewpointListActive && this.filterViewpoints) {
            return viewpointModule.decisionViewpoints;
        } else {
            return this.unfilteredViewpoints;
        }
    }

    get unfilteredViewpoints() {
        return viewpointModule.unfilteredViewpoints;
    }

    get choices() {
        return choicesModule.unfilteredChoices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get routePath() {
        return this.$route.path;
    }

    get appletLink() {
        return this.generateLink(this.href)
    }

    get tabOptions() {
        return [
            { 
                name: 'User Manager',
                path: '/users'
            },
            {
                name: this.singularViewpointLabel + ' Manager', 
                path: '/viewpoint'
            },
            {
                name: this.singularChoiceLabel + ' Manager',
                path: '/choices'
            },
            {
                name: 'Model Editor',
                path: '/template/builder'
            },
            {
                name: 'List Manager',
                path: '/lists'
            },
            {
                name: 'Content Editor',
                path: '/choice'
            },
            {
                name: 'Card Editor', 
                path: '/card'
            },
            {
                name: 'Weights & Rules',
                path: '/weight'
            },
            {
                name: 'Ranking',
                path: '/score/bins'
            },
            {
                name: this.singularChoiceLabel + ' Comparison',
                path: '/score/compare'
            },
            {
                name: this.singularViewpointLabel + ' Comparison',
                path: '/score/choice'
            }
        ]
    }

    /* Returns true if element needs to be disabled */
    private checkUiDisable(propId: string) {
        if (!this.uiDisableOverride) {
            if (this.propPaths[propId]) {
                return !this.propPaths[propId].includes(this.currentTab)
            }
        }
        return false;
    }

    private checkPanelVis( panel: string ) {
        if ( this.panelVisible[panel] ) {
            return this.panelVisible[panel].filter((prop) => {
                return !this.checkUiDisable(prop);
            }).length > 0
        }

        return true;
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    private isFactorVisible(resourceId: string) {
        //If no list active or showallFactors button toggled on
        if(this.showNonListFactors || !this.isFactorListActive) {
            //return this.contributingVisibility || (!this.contributingVisibility && this.contributingFactors[resourceId])
            return true;
        }
        //If list active and showAllFactors is off, then filter 
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        } 
       
    }

    private getSubTree(factorResourceId: string): { id: string, name?: string, children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition
            && (
                factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
            )
        ) {
            
        } else {
            
            childrenIds = this.factorResources[this.getTopGroup(factorGroup.id)].childrenIds || [];
        }
        if (!childrenIds) { childrenIds = []; }
        let children = childrenIds
            .filter(id => this.isFactorVisible(id))
            .filter(f => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name
                    }
                }
                return this.getSubTree(cId)
            })

        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children
        }
    }

    private async getUrlProps(urlPath: string) {
        if ( urlPath) {   
            let urlProps = urlPath
                .substring(urlPath.indexOf('?') + 1, urlPath.length)
                .split('&')
            
            for (let i = 0; i < urlProps.length; i++) {
                await this.loadUrlProp(urlProps[i]);
            }
        }
    }

    private async loadUrlProp(item) {
        let currProp = item.split('=');
        /* If Prop is duplicate then convert to array */
        if ( currProp[1] && currProp[1] !== 'undefined' ) {
            if ( this.urlParams[currProp[0]]) {
                /* Push to array otherwise convert to array */
                if (Array.isArray(this.urlParams[currProp[0]])) {
                    this.urlParams[currProp[0]].push(currProp[1])
                } else {
                    this.urlParams[currProp[0]] = [this.urlParams[currProp[0]], currProp[1]]
                }
            } 
            /* Prop is added to urlParams */
            else {
                /* If prop is boolean then convert */
                if (currProp[1] == 'true' || currProp[1] == 'false') {
                    this.$set( this.urlParams, currProp[0], (currProp[1] == 'true') )
                } else {
                    this.$set( this.urlParams, currProp[0], currProp[1] )
                }
            }
        }
    }

    private async updateLink() {
        let link = this.currentTab + '?';
        for (const prop in this.urlParams) {
            if (Array.isArray(this.urlParams[prop])) {
                this.urlParams[prop].forEach((item) => {
                    link += `${prop}=${item}&`
                })
            } else {
                link += `${prop}=${this.urlParams[prop]}&`;
            }
        }
        this.href = link;
    }  

    private selectFactor(newId) {
        this.urlParams['activeFactorId'] = newId;
        this.activeFactorName = this.factorResources[this.urlParams['activeFactorId']] ? 
            this.factorResources[this.urlParams['activeFactorId']].name : '';
    }

    private clear() {
        this.name = "";
        this.href = "";
        this.urlParams = {};
    }

    private async update() {
        if (this.syncedItem) {
            this.syncedItem.name = this.name;
            this.syncedItem.href = this.href;
            this.syncedItem.description = this.description
            await appModule.updateApps({
                decisionId: this.decisionId,
                appId: this.selectedAppId,
                app: this.selectedApp,
            });
            this.name = '';
            this.href = '';
            this.description = '';
            this.showPreview = false;
            this.urlParams = {}
            this.urlLoaded = false;
            this.open = false;
        } else {
            console.log('fail to add child');
        }
    }
    
    private addNewMenu() {
        if (this.name) {
            if (this.syncedItem && this.syncedItem.hasOwnProperty('children')) {
                const child = {
                    id: uuidv4(),
                    description: this.description,
                    name: this.name,
                    href: this.href,
                    children: [],
                };
                
                this.syncedItem.children.push(child);
                appModule.updateApps({
                    decisionId: this.decisionId,
                    appId: this.selectedAppId,
                    app: this.selectedApp,
                });
                this.name = '';
                this.href = '';
                this.urlParams = {}
                this.urlLoaded = false;
                this.open = false;
                this.description = '';
            } else {
                console.log('fail to add child');
            }
        } else {
            this.error = true;
            setTimeout(() => {
               this.error = false; 
            }, 3000);
        }
    }

    private getAppsUrl(url: string) {
        let mainPath: string;
        // '/app2'
        if(url.substring(0,5).toLowerCase() === Urls.APP_EMBED){
            mainPath = Urls.APP_EMBED;
        }else{
            mainPath = Urls.APP_EMBED;
        }
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath;

        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[aApP]*[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            return url;
        } else {
            return mainPath + url;
        }
    }

    private generateLink( appletHref: string ) {
        let link = window.location.origin;
        if(appletHref) {
            link = `${link}${this.getAppsUrl(appletHref)}`;
            link = `${link}homepage=${this.selectedApp.homepage && this.selectedApp.showHomepage}&pinnedLeft=true&appEmbedId=${this.selectedApp.id}&appEmbedMenuId=${this.syncedItem.id}`
            return link
        }
    }

    private async loadDataToUI() {
        this.urlLoaded = true;
        this.firstColumnWidth = parseInt(this.urlParams['viewpointFirstCol']);
        this.dataColumnWidth = parseInt(this.urlParams['viewpointColumnWidth']);
        this.sortOrder = parseInt(this.urlParams['viewpointSort']);

        if (!this.urlParams.hasOwnProperty('decisionId')) { 
            this.urlParams['decisionId'] = this.decisionId;
        }
        if (!this.urlParams.hasOwnProperty('brandingPrimary')) {
            this.$set( this.urlParams,'brandingPrimary', this.brandingPrimary )
        }
        else {
            this.brandingPrimary = this.urlParams['brandingPrimary'];
        }

        if (typeof this.urlParams['viewpointIds'] == 'string') {
            this.urlParams['viewpointIds'] = [this.urlParams['viewpointIds']]
        }
        this.visibleViewpointsInternal = this.urlParams['viewpointIds'];
        this.activeFactorName = this.factorResources[this.urlParams['activeFactorId']] ? 
            this.factorResources[this.urlParams['activeFactorId']].name : '';

        if(this.urlParams['activeViewpointId'] && !(this.urlParams['activeViewpointId'] in  _.keyBy(this.unfilteredViewpoints, 'viewpointId'))) {
            this.alerts.push(`The active ${this.singularViewpointLabel} has been deleted`)
        }
    }

    private async setDefaultValues() {
        const defaultEnables = [ 'editModel', 'editContent', 'editWeights', 'editSumRule', 'editScoringRule', 'editScores', 'editComments', 'chartTop' ];
        defaultEnables.forEach((prop)=> {
            if (!this.urlParams.hasOwnProperty(prop)) {
                this.$set( this.urlParams, prop, true );
            }
        })
    }

    private async getCurrentTab( url: string) {
        let tab = url.substring( 0, url.indexOf('?') )
        this.currentTab = tab.charAt(tab.length - 1) == '/' ? 
            tab.substr(0, tab.length - 1) : tab;
    }

    private async filterUnusedParams() {
        const filtered = Object.keys(this.urlParams)
            .filter((key) => {
                return !this.checkUiDisable(key);
            })
            .reduce((obj, key) => {
                obj[key] = this.urlParams[key];
                return obj;
            }, {});
        this.urlParams = {...filtered}
    }

    @Watch('open')
    private async valueInput() {
        this.alerts = [];
        if (this.open) {
            if (this.syncedItem && this.isUpdate) {
                await this.getUrlProps(this.syncedItem.href);
                await this.getCurrentTab(this.syncedItem.href)
                await this.loadDataToUI()
                await this.filterUnusedParams()
                await this.setDefaultValues()
                await this.updateLink();
                this.name = this.syncedItem.name;
                this.href = this.syncedItem.href;
                this.description = this.syncedItem.description;
                
            } else {
                this.href = this.currentUrl.path + this.currentUrl.params
                await this.getUrlProps(this.href);
                await this.getCurrentTab(this.href);
                await this.loadDataToUI();
                await this.filterUnusedParams();
                await this.setDefaultValues()
                await this.updateLink();
            }
        }
        
    }

    @Watch('autocreate')
    private onAutocreateChange() {
        if(!this.autocreate) {
            this.templateViewpoint = '';
        }
    }

    @Watch('urlParams', {immediate: true, deep: true})
    private onParamsChange() {
        if (this.urlLoaded) {
            this.updateLink()
        }
    }

    @Watch('currentTab')
    private async onCurrentTabChange() {
        if (this.urlLoaded) {
            await this.filterUnusedParams()
            await this.setDefaultValues()
            this.updateLink()
        }
    }

    @Watch('firstColumnWidth')
    private onfirstColumnWidth(val) {
        this.urlParams['viewpointFirstCol'] = val;
        this.urlParams['choiceFirstCol'] = val;
    }

    @Watch('dataColumnWidth')
    private onDataColumnWidth(val) {
        this.urlParams['viewpointColumnWidth'] = val;
        this.urlParams['rankChoiceCol'] = val;
        this.urlParams['choiceColumnWidth'] = val;
    }

    @Watch('sortOrder')
    private onSortOrderChange(val) {
        this.urlParams['choiceSort'] = val;
        this.urlParams['viewpointSort'] = val;
    }

    @Watch('filterViewpoints')
    onChangeFilterViewpoints() {
        if(!(this.templateViewpoint in _.keyBy(this.viewpoints, 'viewpointId'))) {
            this.templateViewpoint = '';
        }
    }

    @Watch('brandingPrimary')
    onChangeBrandingPrimary(val) {
        if (this.urlLoaded) {
            if (val && val != '') {
                let re = /^([0-9A-F]{3}){1,2}$/i;
                if(re.test(val)) {
                    this.$set( this.urlParams,'brandingPrimary', val )       
                }
            }
            else {
                this.$set( this.urlParams,'brandingPrimary', '' )
            }
        }
    }

    @Emit('save')
    private save() {
        if (this.isUpdate) {
            this.update();
        } else {
            this.addNewMenu();
        }
        this.alerts = [];
    }

    @Emit('cancel')
    private cancel() {
        this.urlLoaded = false;
        this.name = '';
        this.href = '';
        this.open = false;
        this.alerts = [];
        this.urlParams = {}
        this.showPreview = false;
    }
}
